import React from 'react';
import { View } from 'react-native';
import { Image } from 'react-native-web';
import TextWithIconLine from './TextWithIconLine';
import { img_promotion_1, img_promotion_2 } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const ChoosePromotion = ({ globJSON }) => {
  const myStyles = {
    img_promotion_1: {
      width: 160,
      height: 143,
    },
    img_promotion_2: {
      width: 160,
      height: 143,
      marginLeft: 14,
    },
    container: {
      flexDirection: 'row',
      paddingHorizontal: 6,
      paddingStart: 15,
    },
  };
  return (
    <View>
      <TextWithIconLine globJSON={globJSON} />
      <View style={myStyles.container}>
        <Image
          fadeDuration={0}
          style={myStyles.img_promotion_1}
          source={img_promotion_1}
        />
        <Image
          fadeDuration={0}
          style={myStyles.img_promotion_2}
          source={img_promotion_2}
        />
      </View>
    </View>
  );
};
export default ChoosePromotion;
